import { Button } from '../Button';
import {
  Content,
  Cta,
  Image,
  Placeholder,
  Subtitle,
  Title,
  Wrapper,
} from './FeaturedBanner.styles';
import type { FeaturedBannerProps } from './FeaturedBanner.types';

export function FeaturedBanner({
  title,
  subtitle,
  imageUrl,
  imageAlt = '',
  ctaLabel,
  onCtaClick,
  ariaLabel,
  noImageLabel = 'No image',
}: FeaturedBannerProps) {
  return (
    <Wrapper aria-label={ariaLabel}>
      {imageUrl ? (
        <Image src={imageUrl} alt={imageAlt} />
      ) : (
        <Placeholder>{noImageLabel}</Placeholder>
      )}
      <Content>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <Cta>
          <Button type="button" variant="primary" size="small" onClick={onCtaClick}>
            {ctaLabel}
          </Button>
        </Cta>
      </Content>
    </Wrapper>
  );
}
